import { Route } from '@utils/types';
import React from 'react';

const Login = React.lazy(() => import('@pages/login'));
const AvailableBenefits = React.lazy(() => import('@pages/available-benefits'));
const PaymentStatus = React.lazy(() => import('@pages/payment-status'));
const ReceiptQR = React.lazy(() => import('@pages/receipt-qr'));
const NotFound = React.lazy(() => import('@pages/not-found'));
const MyBookings = React.lazy(() => import('@pages/my-bookings'));
const TermsAndConditions = React.lazy(() => import('@pages/terms-conditions'));

export const routes: Route[] = [
  {
    path: '/',
    key: 'login',
    element: <Login />,
  },
  {
    path: '/my-bookings',
    key: 'my-bookings',
    element: <MyBookings />,
  },
  {
    path: '/available-benefits',
    key: 'available-benefits',
    element: <AvailableBenefits />,
  },
  {
    path: '/payment-status/:transactionId',
    key: 'payment-status',
    element: <PaymentStatus />,
  },
  {
    path: '/receipt/:transactionId',
    key: 'receipt-qr',
    element: <ReceiptQR />,
  },
  {
    path: '/terms-conditions',
    key: 'terms-conditions',
    element: <TermsAndConditions />,
  },
  {
    path: '*',
    key: 'not-found',
    element: <NotFound />,
  },
];
